<template lang="pug">
.iDropdown
  Dropdown(trigger="click")
    a(href="javascript:void(0)" v-show='!isFocus' @click='changeTitle') {{contentX}}
      Icon(type="ios-arrow-down")
    Input(
        v-show="isFocus"
        ref="iTitle"
        @on-blur='changeContent'
        v-model.trim='contentX'
        @keyup.enter.native="changeContent")
    DropdownMenu(slot="list" v-if='type==="row"')
      DropdownItem(@click.native='moveUp') 上移选项
      DropdownItem(@click.native='moveDown') 下移选项
      DropdownItem(@click.native='delRow') 删除
    DropdownMenu(slot="list" v-else)
      DropdownItem(@click.native='moveLeft') 左移选项
      DropdownItem(@click.native='moveRight') 右移选项
      DropdownItem(@click.native='delCol') 删除
</template>

<script>
export default {
  name: "iDropdown",
  props: {
    content: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "col"
    },
    inputWidth: {
      type: String,
      default: "100px"
    }
  },
  data() {
    return {
      isFocus: false,
      title: "",
      contentX: this.content
    };
  },
  methods: {
    moveUp() {
      this.$emit("move-up");
    },
    moveDown() {
      this.$emit("move-down");
    },
    delRow() {
      this.$emit("del-row");
    },
    moveLeft() {
      this.$emit("move-left");
    },
    moveRight() {
      this.$emit("move-right");
    },
    delCol() {
      this.$emit("del-col");
    },
    changeTitle() {
      this.isFocus = true;
      this.$nextTick(() => {
        this.$refs.iTitle.focus();
      });
    },
    changeContent() {
      this.isFocus = false;
      const value = this.contentX;
      if (value) {
        this.isFocus = false;
        this.$emit("change-content", value);
      }
    }
  }
};
</script>

<style lang="stylus">
.iDropdown
  background rgba(255, 255, 255, 1)
  .ivu-input
    width 60%
    padding 0
    margin 0
</style>
